<template>
    <div class="col-lg-9 c-content-main">
        <div class="tile">
            <h3 class="tile-title is-line">{{$t('token')}}</h3>
            <div class="tile-body" v-if="$store.state.user.permissions.includes('tokenSetup')">
                <div class="c-config-content">
                    <h4>{{$t('tokenList')}}</h4>
                    <div v-if="firstLoading">
                        <skeleton-loading>
                            <row>
                                <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
                            </row>
                            <row>
                                <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
                            </row>
                        </skeleton-loading>
                    </div>
                    <div v-else>
                        <div class="c-template-table table-responsive c-role-table">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>{{$t('token')}}</th>
                                    <th>{{$t('createTime')}}</th>
                                    <th>{{$t('lastRequestTime')}}</th>
                                    <th class="th-80 text-right">
                                        <span @click="create" class="btn-add"><i class="icon16-plus-circle-gadient"></i></span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody v-if="items.length">
                                <tr v-for="item in items" :key="item._id">
                                    <td>{{sub(item.token,32)}}</td>
                                    <td>{{item.createTime | moment('LL')}}</td>
                                    <td v-if="!item.lastRequestTime">{{$t('notUpdated')}}</td>
                                    <td v-else>{{item.lastRequestTime | moment('LL')}}</td>
                                    <td class="text-right">
                                        <button @click="copy(item.token)" :disabled="delLoading"
                                                class="mr-1 btn btn-outline-gray btn-sm is-border-1"
                                                type="button">
                                            <b-spinner v-if="delLoading" small></b-spinner>
                                            <i class="icon12-copy-primary"></i>
                                        </button>
                                        <button @click="del(item._id)" :disabled="delLoading"
                                                class="mr-1 btn btn-outline-gray btn-sm is-border-1"
                                                type="button">
                                            <b-spinner v-if="delLoading" small></b-spinner>
                                            <i class="icon12-delete-primary"></i>
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                                <tbody v-if="!items.length">
                                <tr>
                                    <td colspan="4" class="text-center">{{$t('noTokenFound')}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
          <div class="tile-body text-center" v-else><h5>{{$t('noPermission')}}</h5></div>
        </div>
    </div>
</template>

<script>
    import list from '../../../mixins/List';
    import crud from '../../../mixins/CRUD';

    export default {
        mixins: [list, crud],
        data: function () {
            return {
                service: '/profile/api',
                autoLoad: true,
                saveLoading: false
            }
        },
        methods: {
            create() {
                this.$swal({
                    title: this.$t('createTokenConfirm'),
                    icon: "warning",
                    showCancelButton: true
                }).then((result) => {
                    if (result.value) {
                        this.saveLoading = true;
                        this.$service.post(this.service).then(response => {
                            if (response.data) {
                                this.load();
                                this.$swal({
                                    title: this.$t('success'),
                                    text: this.$t('created'),
                                    icon: 'success',
                                    toast: true,
                                    position: 'top-end',
                                    timer: 5000,
                                });
                            } else {
                                this.$swal({
                                    title: this.$t('error'),
                                    text: this.$t('createFailed'),
                                    icon: 'error'
                                });
                            }
                        }).catch(error => {
                            if (error.response.data.msg) {
                                this.$swal({
                                    text: error.response.data.msg,
                                    icon: 'error'
                                });
                            }
                        }).finally(() => {
                            this.saveLoading = false;
                        });
                    }
                });
            },
            copy(str) {
                this.$copyText(str).then(() => {
                    this.$swal({
                        text: this.$t('tokenCopied'),
                        icon: 'success',
                        toast: true,
                        position: 'top-end',
                        timer: 5000,
                    });
                }, () => {
                    this.$swal({
                        title: this.$t('error'),
                        text: this.$t('copyFailed'),
                        icon: 'error'
                    });
                })
            },
            sub(str, length, ending) {
                if (length == null) {
                    length = 100;
                }
                if (ending == null) {
                    ending = '...';
                }
                if (str.length > length) {
                    return str.substring(0, length - ending.length) + ending;
                } else {
                    return str;
                }
            },
        }
    }
</script>